import React, { useEffect, useState, lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import { fetchHomeWorkflow } from '../../redux/homeActions';
import { fetchMeWorkflow } from '../../redux/userActions';
import { videoReadCountWorkflow } from '../../redux/videoActions';
import { HomePage } from '../../api';
import { isRightToLeftDirection } from '../../util/utils';
import LoaderBlock from '../LoaderBlock';
import withRouter from '../../util/withRouter';

const Home = lazy(() => import('../Home'));

const HomeContainer = (props) => {
    const [popularBooks, setPopularBooks] = useState([]);
    const [trendingBooks, setTrendingBooks] = useState([]);
    const [newlyAddedBooks, setNewlyAddedBooks] = useState([]);

    useEffect(() => {
        if (!navigator.onLine) {
            props.navigate('/offline');
        }
    }, []);

    useEffect(() => {
        props.fetchHomeWorkflow().then(() => {
            localStorage.setItem('language', props.localeLanguage);

            if (props.localeLanguage) {
                HomePage.fetchPopularBooks()
                    .then((response) => response.json())
                    .then((data) => setPopularBooks(data.data));

                HomePage.fetchTrendingBooks()
                    .then((response) => response.json())
                    .then((data) => setTrendingBooks(data.data));

                HomePage.fetchNewArrivals()
                    .then((response) => response.json())
                    .then((data) => setNewlyAddedBooks(data.data));
            }
        });
    }, [props.localeLanguage, props.fetchHomeWorkflow]);

    const {
        newArrivals,
        mostRead,
        viewport,
        profile,
        isLoggedIn,
        currentLangauge,
        videos,
        readingLists,
    } = props;

    return (
        <Suspense fallback={<LoaderBlock />}>
            <Home
                newArrivals={newArrivals}
                mostRead={mostRead}
                popularBooks={popularBooks}
                trendingBooks={trendingBooks}
                newlyAddedBooks={newlyAddedBooks}
                viewport={viewport}
                hasUserHistory={profile.hasHistory}
                profile={profile}
                videos={videos}
                isLoggedIn={isLoggedIn}
                currentLangauge={currentLangauge}
                readingLists={readingLists}
                videoReadCountWorkflow={videoReadCountWorkflow}
                isRightToLeftDirection={isRightToLeftDirection}
            />
        </Suspense>
    );
};

const mapStateToProps = ({ home, viewport, user }) => ({
    newArrivals: home.newArrivals,
    mostRead: home.mostRead,
    viewport,
    profile: user.profile,
    isLoggedIn: user.isLoggedIn,
    currentLangauge: user.currentLangauge,
    videos: home.videos,
    readingLists: home.readingLists,
    localeLanguage: home.localeLanguage,
});

const mapDispatchToProps = {
    fetchHomeWorkflow,
    fetchMeWorkflow,
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(HomeContainer)
);
